export const PAYMENT_REQUEST_STATUS = {
  requested: "requested",
  declined: "declined",
  cancelledClient: "cancelled_client",
  cancelledProvider: "cancelled_provider",
  refundedProvider: "refunded_provider",
  paid: "paid",
} as const

export type PaymentRequestStatus =
  (typeof PAYMENT_REQUEST_STATUS)[keyof typeof PAYMENT_REQUEST_STATUS]

export type PaymentRequestCustomer = {
  name: string
  email: string | null
  phone: string | null
}

export type PaymentRequestListItem = {
  ident: string
  customer: PaymentRequestCustomer
  description: string | null
  amountGross: number
  status: PaymentRequestStatus
  createdAt: Date
}

export type PaymentRequest = PaymentRequestListItem & {
  user: string | null
  amountVat: number
  customerCreated: boolean
  lastSentAt: Date | null
}
